export default __webpack_public_path__ + "static/O0213-3d086104e50a970a2c2b63f962052e0b.png";